import { render, staticRenderFns } from "./headerDiscount.vue?vue&type=template&id=16ec0183&scoped=true"
import script from "./headerDiscount.vue?vue&type=script&lang=js"
export * from "./headerDiscount.vue?vue&type=script&lang=js"
import style0 from "./headerDiscount.vue?vue&type=style&index=0&id=16ec0183&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ec0183",
  null
  
)

export default component.exports